export default __webpack_public_path__ + "static/exe-267879532735870f714c2cd4e8aa55c5.png";